import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql: DocumentNode = gql`
fragment WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace on Workbook {
  id
  name
  vizportalUrlId
  projectName
  projectVizportalUrlId
  owner {
    name
    username
    domain
  }
  sheetsConnection {
    totalCount
  }
}
`;
